module.exports = __webpack_public_path__ + "images/button-circle-grey.svg";